const PERF_PREFIX = '[URV_PERF]'

let currentFlow = null
let flowCounter = 0

function nowMs () {
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    return performance.now()
  }
  return Date.now()
}

function roundMs (value) {
  return Math.round(value * 100) / 100
}

function ensureFlow () {
  if (!currentFlow) {
    flowCounter += 1
    const startedAt = nowMs()
    currentFlow = {
      flow_id: `urv_${Date.now()}_${flowCounter}`,
      tick_id: null,
      startedAt,
      lastAt: startedAt
    }
  }

  return currentFlow
}

function normalizePayload (payload = {}) {
  return Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined)
  )
}

export function markPerfEvent (event, payload = {}) {
  const flow = ensureFlow()
  const normalizedPayload = normalizePayload(payload)
  const eventAt = nowMs()

  if (normalizedPayload.tick_id !== undefined && normalizedPayload.tick_id !== null) {
    flow.tick_id = normalizedPayload.tick_id
  }

  console.log(PERF_PREFIX, event, {
    flow_id: flow.flow_id,
    tick_id: flow.tick_id,
    at_ms_from_flow_start: roundMs(eventAt - flow.startedAt),
    duration_ms_from_previous_event: roundMs(eventAt - flow.lastAt),
    ...normalizedPayload
  })

  flow.lastAt = eventAt

  if (event === 'ready_for_next_checkin') {
    currentFlow = null
  }
}
